const ModalHeader = ({ text }) => (
  <h3 className="py-3 px-4 sm:py-4 sm:px-6 text-lg text-white font-bold bg-primary w-full">
    {text}
  </h3>
);

export default ModalHeader;
